<!--
   Created by qing on 2020/12/23
   Des: 处理表单弹窗，和处理表单页面（/handFormWrapper）一样
-->
<template>

  <van-popup
    class="handle-form-popup"
    v-model="visibleInfo.visible"
    :overlay="false"
    get-container="body"
    :style="{ height: '100%', width: '100%' }"
    @close="beforeClose"
    position="right">
    <div class="handle-form-popup-container" v-if="visibleInfo.visible">
      <div class="form-handle-container" v-wechat-title="formSet.formName" v-if="formSet.isInit && !errorInfo">
        <van-tabs
          v-model="tabActive"
          animated
          :ellipsis="false"
          @click="onClickTab">
          <van-tab name="detail" title="表单详情">

            <div class="form-detail-container-wrapper">

              <div
                v-show="tabActive === 'detail'"
                :style="{height: btnList.length? 'calc(100% - 44px - 51px)' : 'calc(100% - 44px)'}"
                class="form-detail-container">
                <header :style="{height: formApplyStatus === 'RUNNING' ? '145px' : '155px'}">
                  <div class="header-state-bar">
                    <div class="header-state-bar-wrapper" :style="{backgroundColor: currentStatusBackground}">
                      <van-icon v-if="formApplyStatus === 'AGREE'" name="passed" color="#09BB07"></van-icon>
                      <van-icon v-if="formApplyStatus === 'REJECT'" name="close" color="#F76260"></van-icon>
                      <van-icon v-if="formApplyStatus === 'RUNNING'" name="clock-o" color="#F67617"></van-icon>
                      <div
                        class="form-state"
                        :style="{color: currentStatusTextColor}">
                        {{currentStatusText}}
                      </div>
                    </div>
                  </div>
                  <div class="header-content" v-if="currentFormDetail">
                    <div class="header-content-title">
                      <div class="step-container">
                        <van-icon name="cluster-o" color="#F67617"></van-icon>
                        <span class="step-name">{{ stepName }}</span>
                      </div>
                      <div>
                        <van-button
                          class="print-button"
                          type="default"
                          size="mini"
                          @click="print">
                          <i class="iconfont icon-print"></i>
                          打印
                        </van-button>
                        <van-button
                          v-if="formApplyStatus === 'RUNNING'"
                          type="default"
                          icon="fire-o"
                          size="mini" @click="remind">
                          催办
                        </van-button>
                      </div>
                    </div>
                    <div class="user-info">
                      <span>发起人：</span>
                      <van-image
                        width="26"
                        height="26"
                        style="min-width: 26px;"
                        round
                        :src="currentFormDetail.headImg">
                      </van-image>
                      <span class="user-name">{{currentFormDetail.userName}}</span>
                    </div>
                    <van-progress
                      v-if="formApplyStatus === 'RUNNING'"
                      :percentage="currentFormDetail.progress"
                      :color="progressColor"
                      stroke-width="6">
                    </van-progress>
                    <div v-if="formApplyStatus === 'AGREE'" class="agree-container">
                      <div class="use-time">
                        <strong>总耗时：</strong>
                        {{computeTime(currentFormDetail.totalTime)}}
                      </div>
                      <div class="complete-time">
                        <strong>完成时间：</strong>
                        <span>{{formatDate(currentFormDetail.finishTime)}}</span>
                      </div>
                    </div>
                    <div v-if="formApplyStatus === 'REJECT'" class="reject-container">
                      <div class="reject-user">
                        <strong>拒绝人：</strong>
                        <div>
                          <van-image
                            width="26"
                            height="26"
                            round
                            :src="currentFormDetail.rejectHeadImg">
                          </van-image>
                          <span> {{currentFormDetail.rejectUserName}} </span>
                        </div>
                      </div>
                      <div class="reject-time">
                        <strong>拒绝时间：</strong>
                        <span>{{formatDate(currentFormDetail.rejectTime)}}</span>
                      </div>
                    </div>
                  </div>
                </header>

                <div class="form-handle-content" v-if="formSet.isInit">
                  <Fill :formSet="formSet">
                  </Fill>
                </div>
              </div>

              <footer v-show="tabActive === 'detail'" :style="{height: btnList.length ? '51px' : '0'}">
                <FillBtnList
                  v-if="btnList.length"
                  :btnList="btnList"
                  :feedback="btnFeedback">
                </FillBtnList>
              </footer>

              <print-template-dialog
                v-if="formSet.isInit"
                ref="printTemplateDialog"
                :company-id="formSet.companyId"
                :app-id="formSet.appId"
                :form-id="formSet.formId"
                :instance-id="instanceId"
                scopeType="FLOW"
                :data-id="stepId"
                :push-result-page="false"
                @selectTempComplete="selectTempComplete">
              </print-template-dialog>
            </div>

          </van-tab>
          <van-tab name="log" title="动态">

            <template v-if="formSet.isInit">
              <form-flow-log
                :form-id="formSet.formId"
                :app-id="formSet.appId"
                :instance-id="instanceId"
                :step-id="stepId"
                :formSet="formSet"
                commentLocation="FLOW">
              </form-flow-log>
            </template>
          </van-tab>

          <van-tab
            v-for="form in relateFormList"
            :key="form.recordId"
            :title="form.formName"
            :name="form.recordId">
            <template v-if="form.formType === FORM_TYPE_FORM">
              <div class="relate-form-data__table-container">

                <FormDataView
                  :ref="`formDataView_${form.viewId}`"
                  :form-id="form.dataId"
                  :app-id="form.appId"
                  :view-id="form.viewId"
                  :view-type="form.viewType"
                  :instance-id="instanceId"
                  :active-relate-form="form"
                  :originalFormSet="formSet"
                  :has-add-form="Boolean(form.allowAddData)">
                </FormDataView>
              </div>
            </template>

            <template v-if="form.formType === FORM_TYPE_DASHBOARD">
              <div class="relate-form-data__table-container">
                <iframe
                  :src="dashSrc"
                  width="100%"
                  height="100%"
                  frameborder="0">
                </iframe>
              </div>
            </template>
          </van-tab>
        </van-tabs>

        <ContactBox
          ref="contactBox"
          :field="chargeUserConfig"
          :user-id="$store.state.userId"
          :company-id="$store.state.companyId"
          :hasMember="true"
          :hasDep="false"
          :hasRole="false"
          :has-ext="true"
          :has-label="false"
          :hasCurrent="false"
          :multiple="false"
          :controlOpen="true"
          :availableMembers="forwardAvailableMembers"
          :availableExt="forwardAvailableMembers"
          @selectedComplete="selectForwardToComplete">
        </ContactBox>


        <ApprovalComment
          ref="approvalComment"
          @commentComplete="approvalCommentComplete">
        </ApprovalComment>

        <print-result-popup
          ref="printResultPopup"
          :stackList="stackList"
        ></print-result-popup>

        <FormOrderPopup
          ref="formOrderPopup"
          @submitOrder="submitOrder"
        ></FormOrderPopup>
      </div>

      <div v-else-if="errorInfo" class="empty-data-container" v-wechat-title="`数据获取失败`">
        <img src="../../../assets/images/loadfailed.png" alt="">
        <p>
          {{errorInfo.info}}({{errorInfo.code}})
        </p>
      </div>
      <div
        style="background-color: #ffffff; height: 100%;"
        v-else>
        <van-skeleton
          style="padding-top: 20px;"
          title
          :row="16">
        </van-skeleton>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import {
    AFTER_JUMP_TYPE__CUSTOM,
    AFTER_JUMP_TYPE__DEFAULT,
    AFTER_JUMP_TYPE__URL,
    FORM_FLOW_NOT_INIT,
    FORM_STATUS__READ,
    FORM_TYPE__FILL,
    FORM_WRITE_FIELD_REPEAT,
    MESSAGE_TYPE_APPEND,
    MESSAGE_TYPE_DATA,
    MESSAGE_TYPE_SIGNATURE,
    SUCCESS,
    FORM_TYPE_FORM,
    FORM_TYPE_DASHBOARD,
    FORM_ITEM__RELATE_RECORD,
    FORM_SUBMIT_ERROR,
    FORM_INSTANCE_NOT_EXIST,
    FORM_ITEM__CURRENT_VIEW_USER,
  } from '../../RyForm/types'
  import RyFormSet from "../../RyForm";
  import Fill from '../../RyForm/redact/Fill'
  import FillBtnList from '../../RyForm/redact/FillBtnList'
  import ApprovalComment from "../../component/ApprovalComment"
  import PrintTemplateDialog from "../../component/PrintTemplateDialog";
  import FormFlowLog from "../../component/FormFlowLog";
  import FormDataView from "../../component/FormDataView";
  import PrintResultPopup from "./PrintResultPopup";
  import FormOrderPopup from "../FormOrderPopup";
  import {formatDate} from "../../RyForm/utils"
  import {FORM_VIEW_TYPE_DATA_HANDLE, FORM_VIEW_TYPE_DATA_VIEW} from "../../../assets/types";
  import {base64Decode, handleMessage} from "../../../assets/js/Untis";
  import {ENV_TYPE_LARK_MINI_PROGRAM, ENV_TYPE_SMALLPROGRAM} from "../../store/types";

  export default {
    props: {
      chargeUserConfig: Object,
      stackList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        visibleInfo: {
          visible: false
        },
        appId: '',
        formId: '',
        instanceId: '',
        stepId: '',
        formApplyStatus: 'INIT',
        // 节点名称
        stepName: '',

        currentFlowDetail: null,
        orderErrorMsgList: [],
        FORM_TYPE_FORM,
        FORM_TYPE_DASHBOARD,
        field: {showContact: false},
        tabActive: 'detail',
        btnList: [],
        formSet: new RyFormSet(),
        // 当前表单详情（进度，流转日志...）
        currentFormDetail: null,
        // 步骤状态map
        stepStatusMap: {
          INIT: {
            type: 'INIT',
            name: '发起'
          },
          NOT_START: {
            type: 'NOT_START',
            name: '未开始'
          },
          RUNNING: {
            type: 'RUNNING',
            name: '进行中'
          },
          FINISH: {
            type: 'FINISH',
            name: '完成'
          },
          REJECT: {
            type: 'REJECT',
            name: '拒绝'
          },
          REPULSE: {
            type: 'REPULSE',
            name: '驳回'
          },
          REVOCATION: {
            type: 'REVOCATION',
            name: '撤回',
            color: 'danger'
          },
          STOP_KILL: {
            type: 'STOP_KILL',
            name: '结束秒杀'
          }
        },
        // 按钮列表按钮map
        btnOriginMap: {
          submit: '提交',
          agree: '同意',
          drafts: '暂存',
          reject: '拒绝',
          forward: '转交',
          repulse: '驳回',
          discard: '丢弃',
          revocation: '撤回',
          submitAndPrint: '提交并打印'
        },

        forwardAvailableMembers: [], // 转交范围

        relateFormList: [], // 关联表单
        dashKey: Math.random(),
        dashSrc: '',
        formKey: Math.random(),
        activeRelateForm: null,
        errorInfo: null,
        dataValues: [],
      }
    },
    created() {
    },
    computed: {
      headImage() {
        const headImg = this.formSet.customFormStyle.headImg
        return headImg ? headImg : `${this.$BASE_PATH}/fetch/image?id=437649976726651087.png`
      },
      // 当前状态文本
      currentStatusText() {
        const status = this.formApplyStatus
        switch (status) {
          case "INIT":  // 表单本身状态
            return ''
          case "RUNNING": // 运行中
            return '进行中'
          case "REJECT": // 拒绝
            return '拒绝'
          case "AGREE": // 同意
            return '同意'
          default:
            return ""
        }
      },
      // 当前状态颜色
      currentStatusTextColor() {
        const status = this.formApplyStatus
        switch (status) {
          case "INIT":  // 表单本身状态
            return ''
          case "RUNNING": // 运行中
            return '#4A66FA'
          case "REJECT": // 拒绝
            return '#F76260'
          case "AGREE": // 同意
            return '#09BB07'
          default:
            return ""
        }
      },
      // 当前
      currentStatusBackground() {
        const status = this.formApplyStatus
        switch (status) {
          case "INIT":  // 表单本身状态
            return ''
          case "RUNNING": // 运行中
            return 'rgba(246, 118, 23, 0.2)'
          case "REJECT": // 拒绝
            return 'rgba(247, 98, 96, 0.2)'
          case "AGREE": // 同意
            return 'rgba(9, 187, 7, 0.2)'
          default:
            return ""
        }
      },
      progressColor() {
        if (this.currentFormDetail.progress < 20) {
          return "#f56c6c"
        } else if (20 < this.currentFormDetail.progress < 40) {
          return "#e6a23c"
        } else if (40 < this.currentFormDetail.progress < 60) {
          return "#6f7ad3"
        } else if (60 < this.currentFormDetail.progress < 80) {
          return "#1989fa"
        } else {
          return "#5cb87a"
        }
      }
    },
    components: {
      Fill,
      FillBtnList,
      ApprovalComment,
      FormFlowLog,
      FormDataView,
      PrintTemplateDialog,
      PrintResultPopup,
      FormOrderPopup
    },
    methods: {
      open({appId, formId, instanceId, stepId}) {
        this.formSet = new RyFormSet()
        this.appId = appId
        this.formId = formId
        this.instanceId = instanceId
        this.stepId = stepId
        this.fetchOverview()
        this.fetchStructure()

        this.stackList.push(this.visibleInfo)
        this.visibleInfo.visible = true
      },
      beforeClose() {
        let exit = true
        Object.keys(this.formSet.fields).forEach(fieldId => {
          const field = this.formSet.fields[fieldId]
          if (field && field.showContact) {
            field.showContact = false
            exit = false
          }
        })
        if (!exit) {
          this.stackList.push(this.visibleInfo)
          this.visibleInfo.visible = true
        }
        this.$emit('close')
      },
      fetchOverview() {
        this.$store.dispatch('actionFetchFormApplyOverview', {
          companyId: this.$store.getters.currentCompanyId,
          formId: this.formId,
          appId: this.appId,
          instanceId: this.instanceId,
          stepId: this.stepId
        }).then(info => {
          if (info.flowLogList && info.flowLogList.length > 0) {
            info.flowLogList.forEach((item, idx) => {
              const list = []
              if (item.nextHandle && item.nextHandle.length) {
                const {member, depart, role} = item.nextHandle
                member.map(id => {
                  const user = this.$store.getters.userListMap[id]
                  list.push({
                    name: user.nickname,
                    img: user.headImg
                  })
                })
                role.map(id => {
                  const ro = this.$store.getters.roleListMap[id]
                  list.push({
                    name: ro.roleName,
                    img: ''
                  })
                })
                depart.map(id => {
                  const dep = this.$store.getters.depListMap[id]
                  list.push({
                    name: dep.depName,
                    img: ''
                  })
                })
              }
              info.flowLogList[idx].nextHandleList = list
            })
          }
          this.stepName = info.stepName
          this.currentFormDetail = info
          this.formApplyStatus = info.formApplyStatus
        })
      },

      fetchStructure() {
        this.fetchFlowDetail()
        this.$store.dispatch('actionMergeStructure', {
          formType: FORM_TYPE__FILL,
          formId: this.formId,
          appId: this.appId,
          viewType: 0,
          stepId: this.stepId,
        })
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              return resultObject
            } else {
              this.errorInfo = {
                code: status,
                info
              }
              throw new Error(`${status}: ${info}`)
            }
          })
          .then(({structureInfo, permissionInfo, detailInfo, pluginList, bothRelateList, displayList}) => {
            if (['REJECT', 'AGREE'].includes(this.formApplyStatus)) {
              this.formSet.status = FORM_STATUS__READ
            }

            this.formSet.setStructure(structureInfo)
            if (permissionInfo) {
              this.formSet.setPermission(permissionInfo.permissionList)
            }
            this.formSet.setConf(detailInfo)
            this.formSet.setPlugin(pluginList)
            this.formSet.setBothRelate(bothRelateList)
            this.formSet.setDisplayRule(displayList)

            this.relateFormList.splice(0, this.relateFormList.length)
            const view = detailInfo.viewList.filter(view => view.dataId === this.stepId)[0]
            const showIdList = view ? view.showIdList : []
            detailInfo.relateFormList.forEach(form => {
              if (showIdList.includes(form.recordId)) {
                if (form.viewId === 'dataHandle') {
                  form.viewType = FORM_VIEW_TYPE_DATA_HANDLE
                } else {
                  form.viewType = FORM_VIEW_TYPE_DATA_VIEW
                }
                form.formName = form.showName || form.formName
                this.relateFormList.push(form)
              }
            })

            if (this.instanceId) {
              this.formSet.instanceId = this.instanceId
              return this.getFormValues()
            }
          })
          .then(() => {

            const currentUserField = []
            Object.values(this.formSet.fields).forEach(field => {
              if (field.type === FORM_ITEM__CURRENT_VIEW_USER) {
                currentUserField.push(field)
              }
            })
            if (currentUserField.length) {
              return this.$store.dispatch('actionMemberInfo', {
                companyId: this.formSet.companyId,
                userIdList: [this.$store.getters.userId]
              }).then(res => {
                if (res && Object.keys(res).length) {
                  currentUserField.forEach(field => {
                    const info = res[this.$store.getters.userId]
                    field.value.depart.push(...info.deptIdList)
                    field.value.role.push(...info.roleIdList)
                    field.value.externalTag.push(...info.tagList)
                  })
                }
                this.formSet.computeDisplayResults()
              })
            }
          })
          .then(() => {
            if (this.instanceId && this.formSet.hasRealTimeDataField()) {
              return this.$store.dispatch('actionFormRealTimeDataFieldData', {
                appId: this.formSet.appId,
                formId: this.formSet.formId,
                data: this.formSet.getValues()
              })
                .then(values => {
                  if (values && this.dataValues) {
                    Object.keys(values).forEach(key => {
                      if (this.dataValues.hasOwnProperty(key)) {
                        this.dataValues[key] = values[key]
                      }
                    })
                  }
                  this.formSet.setValues(values)
                })
            }
          })
          .then(() => {
            this.formSet.stepId = this.stepId
            const btnListOpts = {
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              instanceId: this.instanceId,
              stepId: this.stepId
            }
            console.log(this.formSet)
            return Promise.all([
              this.$Socket.init(),
              this.$store.dispatch('actionTopicGet', {
                appId: this.formSet.appId,
                formId: this.formSet.formId,
              }),
              this.$store.dispatch('actionApplyButtonList', btnListOpts)
            ])
          })
          .then(([init, res, btnList]) => {
            this.formSet.tmpTopic = res.tmpTopic
            this.$Socket.subscribe(res.tmpTopic, ({messageType, context, content}) => {
              console.log('$Socket--', messageType, content)
              if (messageType === this.$RySocket.MESSAGE_TYPE_PLUGIN_RESULT) {
                const {resultType, showMsg} = content
                if (showMsg && resultType === 'SUCCESS') {
                  this.$toast.success(showMsg)
                } else if (showMsg && resultType === 'FAIL') {
                  this.$toast.fail(showMsg)
                }
                const changeFlowEvent = new CustomEvent('PLUGIN_RESULT_RECEIVED', {detail: {context, content}})
                document.dispatchEvent(changeFlowEvent)
                return
              }

              handleMessage(this.formSet, {messageType, context, content})
            })

            this.btnList = btnList
            if (btnList.length === 0) {
              this.formSet.status = FORM_STATUS__READ
            }
          })
          .then(() => {
            this.formSet.isInit = true
          })
          .catch(err => {
            console.log(err)
          })
      },
      getFormValues() {
        const opts = {
          companyId: this.formSet.companyId,
          formId: this.formSet.formId,
          instanceId: this.instanceId,
          stepId: this.stepId
        }
        return this.$store.dispatch('actionFetchFormApplyDetail', opts)
          .then(({status, resultObject, info}) => {
            if (status === SUCCESS) {
              this.dataValues = resultObject
              this.formSet.setValues(resultObject)
            } else if (status === FORM_INSTANCE_NOT_EXIST) {
              this.errorInfo = {
                code: status,
                info: '数据已删除。如有疑问请联系系统管理员'
              }
            } else {
              this.errorInfo = {
                code: status,
                info: '数据请求失败，请稍后重试'
              }
            }
          })
      },

      async btnFeedback(command) {

        if (this.currentFlowDetail && this.currentFlowDetail.openPay &&
          (command.originName === 'submit' || command.originName === 'agree')) {
          if (this.$refs.formOrderPopup) {
            this.$refs.formOrderPopup.open({
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              data: this.formSet.getValues(),
              stepId: this.stepId,
              command
            })
          }
        } else {
          this.buttonClick(command)
        }
      },

      submitOrder({command, errList}) {
        this.orderErrorMsgList = errList
        this.buttonClick(command)
      },

      async buttonClick(command) {
        const opts = {
          depList: this.$store.getters.depListMap,
          roleList: this.$store.getters.roleListMap,
          userList: this.$store.getters.userListMap
        }
        if (['submit', 'agree'].includes(command.originName) && this.formSet.checkMissingValue(opts)) {
          this.$toast.fail('存在不符合规范的值')
          return
        }
        const check = await this.checkComputeData()
        const uploading = await this.checkUploadFile()
        if (!check || !uploading) {
          return
        }
        const originName = command.originName
        const toast = this.$toast.loading({
          message: '提交中...',
          forbidClick: true,
          overlay: true
        })
        switch (originName) {
          // 提交
          case 'submit': {
            const changeList = this.formSet.getModified().map(field => {
              return {
                fieldId: field.dataId
              }
            })
            let opts = {
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              data: this.formSet.getValues(),
              changeList: changeList,
              showFieldIdList: this.formSet.fetchShowFieldIdList()
            }
            if (this.instanceId) {
              await this.formApplyHandle({originName: 'submit'})
                .then(res => {
                  console.log('res', res)
                  if (res) {
                    this.submitCallback(res)
                  }
                })
            } else {
              opts.relateHandleMap = {}
              Object.keys(this.formSet.fields).forEach(key => {
                const field = this.formSet.fields[key]
                if (field.type === FORM_ITEM__RELATE_RECORD) {
                  opts.relateHandleMap[key] = {
                    addInstanceList: field.addInstanceList, //新增的实例
                    deleteInstanceList: field.deleteInstanceList //删除的实例
                  }
                }
              })
              // 清空字段错误信息
              this.formSet.clearError()
              await this.$store.dispatch('formApply', opts)
                .then(({status, resultObject, info}) => {
                  if (status === SUCCESS) {
                    this.createOrder({originName, instanceId: resultObject.instanceId})
                    return resultObject
                  } else if (status === FORM_SUBMIT_ERROR && info) {
                    // 表单字段校验未通过
                    const errInfo = JSON.parse(base64Decode(info))
                    console.log('errInfo', errInfo)
                    if (errInfo) {
                      this.formSet.setError(errInfo)
                      this.$dialog.alert({
                        title: '提交验证失败',
                        message: errInfo.errorMessage,
                      }).then(() => {
                        // on close
                      });
                      // this.$toast.fail(errInfo.errorMessage)
                    }
                    throw new Error(`${status} ${info}`)
                  } else if (status === FORM_WRITE_FIELD_REPEAT) {
                    this.$toast.fail({
                      message: info,
                      duration: '2000'
                    })
                    throw new Error(`${status} ${info}`)
                  } else {
                    this.$toast.fail({
                      message: info,
                      duration: '2000'
                    })
                    throw new Error(`${status} ${info}`)
                  }
                })
                .then(res => {
                  this.submitCallback(res)
                }).catch(error => {
                  console.error(error)
                  this.$toast.fail({
                    message: '提交失败，请稍后再试！',
                    duration: '2000'
                  })
                })
            }
          }
            break
          // 同意
          case 'agree':
            const stepInfo = await this.$store.dispatch('actionFormFlowDetail', {
              companyId: this.formSet.companyId,
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              stepId: this.stepId
            }).catch(console.error)

            // if (stepInfo.stepType === 'approval' && stepInfo.enableComment && (!stepInfo.agreeCloseComment || !stepInfo.agreeCloseSignature)) {
            if (stepInfo.stepType === 'approval' &&
              (stepInfo.enableComment && (!stepInfo.commentConfigInfo || stepInfo.commentConfigInfo.agree.show === 'YES') ||
                stepInfo.enableSignature && (!stepInfo.signatureConfigInfo || stepInfo.signatureConfigInfo.agree.show === 'YES'))) {
              if (this.$refs.approvalComment) {
                this.$refs.approvalComment.open({
                  companyId: this.formSet.companyId,
                  appId: this.formSet.appId,
                  formId: this.formSet.formId,
                  showComment: stepInfo.enableComment && (!stepInfo.commentConfigInfo || stepInfo.commentConfigInfo.agree.show === 'YES'),
                  showSignature: stepInfo.enableSignature && (!stepInfo.signatureConfigInfo || stepInfo.signatureConfigInfo.agree.show === 'YES'),
                  enableEmptyComment: stepInfo.commentConfigInfo && stepInfo.commentConfigInfo.agree.enableEmpty === 'YES',
                  enableEmptySignature: stepInfo.signatureConfigInfo && stepInfo.signatureConfigInfo.agree.enableEmpty === 'YES',
                  originName: 'agree'
                })
              }
            } else {
              await this.formApplyHandle({originName: 'agree'})
            }
            break
          // 驳回
          case 'repulse':
            const flowStepInfo = await this.$store.dispatch('actionFormFlowDetail', {
              companyId: this.formSet.companyId,
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              stepId: this.stepId
            }).catch(console.error)

            // if (flowStepInfo.repulseNeedComment || flowStepInfo.repulseNeedSignature) {
            if (flowStepInfo.stepType === 'approval' &&
              (flowStepInfo.enableComment && (!flowStepInfo.commentConfigInfo || flowStepInfo.commentConfigInfo.repulse.show === 'YES') ||
                flowStepInfo.enableSignature && (!flowStepInfo.signatureConfigInfo || flowStepInfo.signatureConfigInfo.repulse.show === 'YES'))) {
              if (this.$refs.approvalComment) {
                this.$refs.approvalComment.open({
                  companyId: this.formSet.companyId,
                  appId: this.formSet.appId,
                  formId: this.formSet.formId,
                  showComment: flowStepInfo.enableComment && (!flowStepInfo.commentConfigInfo || flowStepInfo.commentConfigInfo.repulse.show === 'YES'),
                  showSignature: flowStepInfo.enableSignature && (!flowStepInfo.signatureConfigInfo || flowStepInfo.signatureConfigInfo.repulse.show === 'YES'),
                  enableEmptyComment: flowStepInfo.commentConfigInfo && flowStepInfo.commentConfigInfo.repulse.enableEmpty === 'YES',
                  enableEmptySignature: flowStepInfo.signatureConfigInfo && flowStepInfo.signatureConfigInfo.repulse.enableEmpty === 'YES',
                  originName: 'repulse'
                })
              }
            }  else {
              await this.formApplyHandle({originName: 'repulse'})
            }
            break
          // 暂存 pageType 为 other 和 draft 时有
          case 'drafts': {
            await this.formApplyHandle({originName: 'drafts'})
          }
            break
          // 丢弃
          case 'discard': {
            await this.$dialog.alert({
              title: '确认信息',
              message: '确定丢弃当前表单?'
            }).then(() => {
              return this.formApplyHandle({originName: 'discard'})
            })
          }
            break
          // 转交
          case 'forward':
            await this.$store.dispatch('actionFetchFormForwardChooseList', {
              companyId: this.formSet.companyId,
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              instanceId: this.instanceId,
              stepId: this.stepId,
            }).then(res => {
              this.forwardAvailableMembers.splice(0, this.forwardAvailableMembers.length, ...res)
              if (this.$refs.contactBox) {
                this.$refs.contactBox.open()
              }
            }).catch(console.error)
            break
          // 拒绝
          case 'reject':
            const stepDetail = await this.$store.dispatch('actionFormFlowDetail', {
              companyId: this.formSet.companyId,
              appId: this.formSet.appId,
              formId: this.formSet.formId,
              stepId: this.stepId
            }).catch(console.error)

            // if (stepDetail.stepType === 'approval' && stepDetail.enableComment) {
            if (stepDetail.stepType === 'approval' &&
              (stepDetail.enableComment && (!stepDetail.commentConfigInfo || stepDetail.commentConfigInfo.reject.show === 'YES') ||
                stepDetail.enableSignature && (!stepDetail.signatureConfigInfo || stepDetail.signatureConfigInfo.reject.show === 'YES'))) {
              if (this.$refs.approvalComment) {
                this.$refs.approvalComment.open({
                  companyId: this.formSet.companyId,
                  appId: this.formSet.appId,
                  formId: this.formSet.formId,
                  showComment: stepDetail.enableComment && (!stepDetail.commentConfigInfo || stepDetail.commentConfigInfo.reject.show === 'YES'),
                  showSignature: stepDetail.enableSignature && (!stepDetail.signatureConfigInfo || stepDetail.signatureConfigInfo.reject.show === 'YES'),
                  enableEmptyComment: stepDetail.commentConfigInfo && stepDetail.commentConfigInfo.reject.enableEmpty === 'YES',
                  enableEmptySignature: stepDetail.signatureConfigInfo && stepDetail.signatureConfigInfo.reject.enableEmpty === 'YES',
                  originName: 'reject'
                })
              }
            } else {
              await this.formApplyHandle({originName: 'reject'})
            }
            break
          // 撤回
          case 'revocation':
            await this.formApplyHandle({originName: 'revocation'})
            break
          // 提交并打印
          case 'submitAndPrint':
            if (this.$refs.printTemplateDialog) {
              this.$refs.printTemplateDialog.open()
            }
            break
          default:
            break
        }
        toast.clear()
      },

      // 检测关联数据服务器是否下发完
      checkComputeData() {
        if (this.formSet.submitMap && Object.keys(this.formSet.submitMap).length) {

          let errorType = ''
          if (Object.keys(this.formSet.submitMap).includes(this.formSet.lastSubmitTime)) {
            // 最后一条数据没回来， 数据异常
            errorType = 'EXCEPTION'
          } else {
            // 之前数据没回来， 丢数据
            errorType = 'LOSE_DATA'
          }
          this.$store.dispatch('actionFormMsgErrorUpload', {
            appId: this.formSet.appId,
            formId: this.formSet.formId,
            traceId: this.formSet.traceId,
            errorType,
            deviceType: 'MINI_APP',
            scene: 'CREATE',
            costTime: ''
          }).catch(console.error)
        }
        if (this.formSet.lastSubmitTime !== this.formSet.lastReciveTime && new Date().getTime() - this.formSet.lastSubmitTime < 10000) {
          return this.$dialog.confirm({
            title:'提示',
            message: '等待计算完成后提交数据，否则会丢失数据。如果弹框反复提示请联系客服！',
            confirmButtonText: '强制提交',
            cancelButtonText: '再等等'
          }).then(() => {
            return true
          }).catch(action => {
            return false
          })
        } else {
          return true
        }
      },

      checkUploadFile() {
        if (this.formSet.uploadFileMap && Object.keys(this.formSet.uploadFileMap).length) {
          const uploading = Object.values(this.formSet.uploadFileMap).some(item => item)
          if (uploading) {
            return this.$dialog.confirm({
              title:'提示',
              message: '当前有文件正在上传，是否等待？',
              confirmButtonText: '强制提交',
              cancelButtonText: '再等等'
            }).then(() => {
              return true
            }).catch(action => {
              return false
            })
          } else {
            return true
          }
        } else {
          return true
        }
      },

      fetchFlowDetail() {
        this.$store.dispatch('actionCompanyPaymentApplyFlowDetail', {
          appId: this.formSet.appId,
          formId: this.formSet.formId,
          stepId: this.stepId
        }).then(res => {
          this.currentFlowDetail = res
        }).catch(console.error)
      },

      // 下单、跳转到收银台
      createOrder({originName, instanceId}) {
        if (this.currentFlowDetail &&
          this.currentFlowDetail.openPay &&
          (!this.orderErrorMsgList || !this.orderErrorMsgList.length) &&
          (originName === 'submit' || originName === 'agree')) {

          this.$store.dispatch('actionCompanyPaymentApplyOrderCreate', {
            appId: this.formSet.appId,
            formId: this.formSet.formId,
            instanceId,
            stepId: this.stepId,
          }).then(res => {
            this.$router.push({
              name: 'payment_gateway',
              query: {
                o: res.orderId
              }
            })
          }).catch(console.error)
        }
        this.orderErrorMsgList = null
      },
      print() {
        if (this.$refs.printTemplateDialog) {
          if (this.formApplyStatus === 'RUNNING') {
            this.$refs.printTemplateDialog.open()
          } else {
            this.$refs.printTemplateDialog.open('DATA')
          }
        }
      },
      // 选择模板完成
      selectTempComplete(temp) {
        if (this.$refs.printResultPopup) {
          this.$refs.printResultPopup.open(temp)
        }
      },

      // 选择转交人完成
      selectForwardToComplete(selected) {
        const selectMember = {
          depart: [],
          dynamic: [],
          external: selected.extIds,
          label: [],
          member: selected.memberIds,
          role: []
        }
        this.formApplyHandle({
          originName: 'forward',
          forwardTo: selectMember
        })
      },

      // 表单按钮点击后续操作
      formApplyHandle({originName, approveInfo, comment = '', forwardTo = null}) {
        const remoteChangeList = this.dataValues['changeList'] || []
        const remoteChangeMap = {}
        remoteChangeList.forEach(item => {
          remoteChangeMap[item.fieldId] = item
        })
        const changeList = this.formSet.getModified().map(field => {
          return {
            fieldId: field.dataId,
            lastVersion: remoteChangeMap[field.dataId] ? remoteChangeMap[field.dataId].lastVersion : 0
          }
        })

        const relateHandleMap = {}
        Object.keys(this.formSet.fields).forEach(key => {
          const field = this.formSet.fields[key]
          if (field.type === FORM_ITEM__RELATE_RECORD) {
            relateHandleMap[key] = {
              addInstanceList: field.addInstanceList, //新增的实例
              deleteInstanceList: field.deleteInstanceList //删除的实例
            }
          }
        })

        // 清空字段错误信息
        this.formSet.clearError()
        return this.$store.dispatch('actionFormApplyHandle', {
          appId: this.formSet.appId,
          formId: this.formSet.formId,
          instanceId: this.instanceId,
          stepId: this.stepId,
          handleAction: originName,
          comment,              // 评论
          forwardTo,            // 转发人
          approveInfo,
          data: this.formSet.getValues(),
          changeList,
          relateHandleMap,
          showFieldIdList: this.formSet.fetchShowFieldIdList()
        }).then(({status, resultObject, info}) => {
          if (status === SUCCESS) {
            this.createOrder({originName, instanceId: this.instanceId})
            // 表单提交时因为有提交后设置不能直接调用submit回调
            if (originName !== 'submit') {
              this.callUp(originName)
            }
            this.$toast.success('操作成功！')
            console.log('resultObject', resultObject)
            return resultObject
          } else if (status === FORM_SUBMIT_ERROR && info) {
            // 表单字段校验未通过
            const errInfo = JSON.parse(base64Decode(info))
            console.log('errInfo', errInfo)
            if (errInfo) {
              this.formSet.setError(errInfo)
              this.$dialog.alert({
                title: '提交验证失败',
                message: errInfo.errorMessage,
              }).then(() => {
                // on close
              });
            }
          } else {
            this.$toast.fail({
              message: info,
              duration: '2000'
            })
          }
        }).catch((error) => {
          console.error(error)
        })
      },

      // submit callback 提交后回调
      submitCallback(res) {
        const visibleInfo = this.stackList.pop()
        visibleInfo.visible = false
        this.$emit('handleComplete')
      },

      // 向上调用事件
      callUp(originName) {
        const visibleInfo = this.stackList.pop()
        visibleInfo.visible = false
        this.$emit('handleComplete')
      },
      approvalCommentComplete(approveInfo) {
        this.formApplyHandle({
          originName: approveInfo.originName,
          approveInfo: {
            comment: approveInfo.comment,
            imageList: [], //预留 目前传空数组
            signatureUrl: approveInfo.signatureUrl
          }
        })
      },

      // 对比修改内容的表单内容对比table渲染函数
      valueFormatter(fieldId, value) {
        const opts = {
          depList: this.$store.getters.depListMap,
          roleList: this.$store.getters.roleListMap,
          userList: this.$store.getters.userListMap
        }
        return this.formSet.valueToString(fieldId, value, opts)
      },
      remind() {
        this.$store.dispatch('actionFormRemind', {
          appId: this.formSet.appId,
          companyId: this.formSet.companyId,
          formId: this.formSet.formId,
          instanceId: this.instanceId,
          stepId: this.stepId
        }).then(res => {
          this.$toast.success('催办成功！')
        }).catch(console.error)
      },
      // 时间转换方法
      formatDate(d) {
        return formatDate(d)(`yyyy-MM-dd HH:mm:ss`)
      },
      // 时间差转中文
      computeTime(timestamp) {
        let time = ''
        let remainSecond = timestamp % (60 * 1000)
        let minute = (timestamp - remainSecond) / (60 * 1000)
        if (minute > 60) {
          let remainMinute = minute % 60
          let hour = (minute - remainMinute) / 60
          if (hour > 24) {
            let remainHour = hour % 24
            let day = (hour - remainHour) / 24
            time = day + '天' + (remainHour === 0 ? '' : remainHour + '小时')
          } else {
            time = hour + '小时' + (remainMinute === 0 ? '' : remainMinute + '分钟')
          }
        } else {
          if (minute === 0) {
            time = '1分钟'
          } else {
            time = minute + '分钟'
          }
        }
        return time
      },

      onClickTab(name) {
        console.log(name)
        if (name === 'detail' || name === 'log') {
          return
        }
        this.activeRelateForm = this.relateFormList.filter(form => form.recordId === name)[0]
        console.log(this.relateFormList, this.activeRelateForm)
        if (this.activeRelateForm.formType === FORM_TYPE_FORM) {
          this.formKey = Math.random()
          const key = `formDataView_${this.activeRelateForm.viewId}`
          console.log(this.$refs, key, this.$refs[key])
          if (this.$refs[key] && this.$refs[key][0]) {
            this.$refs[key][0].restartRequest()
          }
        } else if (this.activeRelateForm.formType === FORM_TYPE_DASHBOARD) {
          this.dashSrc = ``
          const toast = this.$toast.loading({message: '加载中...'})
          this.$store.dispatch('actionNodeSave', {
            companyId: this.$store.getters.currentCompanyId,
            userId: this.$store.getters.userId,
            appId: this.activeRelateForm.appId,
            dashboardId: this.activeRelateForm.dataId,
            token: this.$store.state.token,
            isFormRelate: 1,
            dashFilterList: this.activeRelateForm.dashFilterList,
            env: this.$store.getters.env,
            fields: Object.values(this.formSet.fields).map(field => {
              return {
                dataId: field.dataId,
                type: field.type,
                value: field.value
              }
            })
          })
            .then(res => {
              this.dashKey = Math.random()
              if (process.env.NODE_ENV === 'production') {
                this.dashSrc = `${location.origin}${this.$DS_BASE_PATH}/#/dashboard?key=${res.nodeKey}`
              } else {
                this.dashSrc = `http://127.0.0.1:8082/#/dashboard?key=${res.nodeKey}`
              }
            })
            .catch(console.error)
            .finally(() => {
              toast.clear()
            })
        }
      }
    }
  }
</script>

<style lang="less">

  .handle-form-popup {

    .handle-form-popup-container {
      width: 100%;
      height: calc(100% - env(safe-area-inset-bottom));

      .form-handle-container {
        height: 100%;
        /*height: 100%;*/
        box-sizing: border-box;
        overflow: hidden;
        position: relative;

        .van-tabs {
          height: 100%;
          border-bottom: 1px solid #e6e6e6;

          .van-tabs__content {
            height: 100%;

            .van-tab__pane {
              height: 100%;
            }
          }
        }

        .header-state-bar {
          height: 30px;
          position: fixed;
          top: 0;
          right: 0;
          left: 0;
          background-color: #ffffff;
          z-index: 3;

          .header-state-bar-wrapper {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .form-state {
              font-size: 14px;
              margin-left: 5px;
            }
          }
        }

        .form-detail-container-wrapper {
          height: 100%;

          .form-detail-container {
            height: calc(100% - 44px - 51px);
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            overflow: auto;
            -webkit-overflow-scrolling: touch;

            .form-handle-content {
              flex: 1;
            }

            > header {
              box-sizing: border-box;
              background-color: #fff;
              height: 145px;
              border-bottom: 1px solid #ebedf0;
              padding-top: 30px;

              .header-content {
                display: flex;
                flex-direction: column;

                .header-content-title {
                  display: flex;
                  justify-content: space-between;
                  padding: 0 10px 0 20px;
                  align-items: center;
                  margin: 10px 0;

                  .print-button {
                    font-size: 12px;

                    i {
                      font-size: 12px;
                    }
                  }

                  > div {
                    display: flex;
                    align-items: center;
                  }

                  .step-container {
                    width: calc(100% - 140px);

                    .step-name {
                      margin-left: 10px;
                      color: #282828;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      word-wrap: break-word;
                    }
                  }

                  .user-name {
                    margin: 0 10px;
                    color: #282828;
                    font-size: 14px;
                    max-height: 20px;
                    max-width: 60px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-wrap: break-word;
                  }
                }

                .user-info {
                  margin-left: 10px;
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                  color: #676767;

                  .van-image {
                    margin-right: 10px;
                  }
                }

                .van-progress {
                  margin: 10px;
                }

                .agree-container,
                .reject-container {
                  margin: 5px 10px;

                  .reject-user {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: #676767;
                    margin-bottom: 5px;

                    > :nth-child(2) {
                      display: flex;
                      align-items: center;

                      span {
                        margin-left: 10px;
                      }
                    }
                  }

                  .use-time,
                  .complete-time,
                  .reject-time {
                    font-size: 14px;
                    color: #676767;
                    margin-bottom: 10px;
                  }
                }

                .agree-container {
                  margin: 10px;
                }
              }

            }
          }

          > footer {
            display: flex;
            box-sizing: border-box;
            border-top: 1px solid #ebedf0;
            height: 51px;
            width: 100%;
            background-color: #FFFFFF;
            position: relative;
            bottom: 0;
            z-index: 3;
          }
        }

        .relate-form-data__table-container {
          width: 100%;
          height: calc(100% - 44px);
        }
      }
    }
  }
</style>
